// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__MB1OI","inputDescription":"styles_inputDescription__139TT"};